import { select, scaleOrdinal, pie as d3Pie, arc } from 'd3';
import { entries } from 'd3-collection';
import Margin from '../Base/margin';
import Svg from '../Base/svg';

import { PieCtrParms } from '../types';

export default class Pie {
  elementId: string;
  element: Svg;
  dataRaw = [];

  height = 450;
  width = 450;
  margin: Margin;
  radius = 0;

  constructor(params?: PieCtrParms) {
    if (params?.elementId) this.elementId = params.elementId;
    if (params?.data) this.dataRaw = params.data;
    if (params?.height) this.height = params.height;
    if (params?.width) this.width = params.width;
    if (params?.radius) this.radius = params.radius;

    this.margin = new Margin(params?.margin);
    this.radius = Math.min(this.width, this.height) / 2 - this.margin.total();
  }

  render() {
    const { elementId, height, width } = this;
    const transform = `translate(${width / 2}, ${height / 2})`;
    this.element = new Svg({ elementId, height, width, transform });

    this.element.draw();

    // TODO: Need to make scale definitions and portion drawing more dynamic / abstracted
    const color = scaleOrdinal()
      //   .domain()
      .range(['#7EA8CB', '#4682B4', '#7BA6C9', '#A2C0D9', '#CFDFEC']);

    const pie = d3Pie().value(function (d) {
      // @ts-ignore
      return d.value;
    });
    const data = pie(entries(this.dataRaw));
    this.element.d3Svg
      .selectAll('portions')
      .data(data)
      .enter()
      .append('path')
      // @ts-ignore
      .attr('d', arc().innerRadius(0).outerRadius(this.radius))
      // @ts-ignore
      .attr('fill', function (d) {
        // @ts-ignore
        return color(d.data.key);
      })
      .attr('stroke', '#BBDAEA')
      .style('stroke-width', '2px')
      .style('opacity', 0.7);
  }

  // loadData(raw: any, options?: { test: '' }) {
  //   const width = 450;
  //   const height = 450;
  //   const margin = 40;

  //   const radius = Math.min(width, height) / 2 - margin;

  //   const svg = select(this.elementId)
  //     .append('svg')
  //     .attr('width', width)
  //     .attr('height', height)
  //     .append('g')
  //     .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');

  //   const color = scaleOrdinal()
  //     //   .domain()
  //     .range(['#7EA8CB', '#4682B4', '#7BA6C9', '#A2C0D9', '#CFDFEC']);

  //   const pie = d3Pie().value(function (d) {
  //     // @ts-ignore
  //     return d.value;
  //   });
  //   const data_ready = pie(entries(raw));

  //   svg
  //     .selectAll('whatever')
  //     .data(data_ready)
  //     .enter()
  //     .append('path')
  //     // @ts-ignore
  //     .attr('d', arc().innerRadius(0).outerRadius(radius))
  //     // @ts-ignore
  //     .attr('fill', function (d) {
  //       // @ts-ignore
  //       return color(d.data.key);
  //     })
  //     .attr('stroke', '#BBDAEA')
  //     .style('stroke-width', '2px')
  //     .style('opacity', 0.7);
  // }
}
